import { useCardPreloadStore } from '../providers/CardPreloadProvider';
import useCardSectionSettingsAdapter from '../sections/hooks/useCardSectionSettingsAdapter';
export const useCardContentSections = () => {
  const cardContentSections = useCardPreloadStore(store => store.cardContentSections);
  return cardContentSections;
};
export const useCardWrapperSections = () => {
  const cardWrapperSections = useCardPreloadStore(store => store.cardWrapperSections);
  return cardWrapperSections;
};
export const useCardActionSections = () => {
  const cardActionSections = useCardPreloadStore(store => store.cardActionSections);
  return cardActionSections;
};
export const useCardContentSectionSettings = () => {
  const {
    contentSectionSettings
  } = useCardSectionSettingsAdapter();
  return contentSectionSettings;
};
export const useAllCardSectionSettingConfigs = () => {
  const {
    sectionSettingConfigs
  } = useCardSectionSettingsAdapter();
  return sectionSettingConfigs;
};
export const useActionSectionKeys = () => {
  const {
    actionSectionKeys
  } = useCardSectionSettingsAdapter();
  return actionSectionKeys;
};
export const useQuickActionSettings = () => {
  const {
    quickActionSettings
  } = useCardSectionSettingsAdapter();
  return quickActionSettings;
};
export const useCardSectionSettingsLoading = () => {
  const {
    cardSectionSettingsLoading
  } = useCardSectionSettingsAdapter();
  return cardSectionSettingsLoading;
};
export const useCardSectionSettingsError = () => {
  const {
    cardSectionSettingsError
  } = useCardSectionSettingsAdapter();
  return cardSectionSettingsError;
};